import React, { useEffect } from 'react'
import { ThemeProvider } from 'styled-components/native'
import { ToastProvider } from 'react-native-toast-notifications'
import { Provider } from 'react-redux'
import { NativeBaseProvider } from 'native-base'
import { getTheme } from '@hedgit/lib/theme/index'

import { store } from './store'
import Navigator from './routes'

const App = () => {
  useEffect(() => {
    console.log('ENV', process.env.REACT_APP_ENV_NAME)
  }, [])

  const theme = getTheme()
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <NativeBaseProvider theme={theme}>
          <ToastProvider>
            <Navigator />
          </ToastProvider>
        </NativeBaseProvider>
      </ThemeProvider>
    </Provider>
  )
}

export default App
